import AppPage from '../../mixins/app-page'
import AppTitle from '../app-title'
import AppImg from '../app-img'
import AppBtn from '../app-btn'
import AppSeasonComingSoon from '../app-season-coming-soon'

export default
{
    name: 'page-teams',

    mixins:
    [
        AppPage
    ],

    components: {
        AppTitle,
        AppImg,
        AppBtn,
        AppSeasonComingSoon
    },

    mounted()
    {
        if (this.contentPage.list.length > 0)
        {
            this.eventHub.$emit('bg-change', '/static/bg/bg-teams.jpg')
        }
        else
        {
            this.eventHub.$emit('bg-change', '/static/bg/bg-coming-soon.jpg')
        }
    },

    methods:
    {
        getTeamUrlBySlug(slug)
        {
            return this.$root.getPageURLFromID('teamProfile').replace(':slug', slug).replace('/:filter', '')
        },

        openModalRegister(observeId)
        {
            this.$root.openModalPlay('team', observeId)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-teams/script.js